import {
  useDashboardApi,
  useUserApi,
  useDeviceApi,
  useWeatherApi,
  useCameraApi,
  useAuthApi
} from '@wision/api';

export default defineNuxtPlugin(() => {
  let cookies : string | undefined;
  if (import.meta.server) {
    cookies = useRequestHeaders(['cookie']).cookie;
  }

  const config = useRuntimeConfig();
  const params = [config.public.apiHost, import.meta.server, cookies] as const;

  const dashboard = useDashboardApi(...params);
  const user = useUserApi(...params);
  const weather = useWeatherApi(...params);
  const device = useDeviceApi(config.public.apiHost, import.meta.server, cookies);
  const camera = useCameraApi(config.public.apiHost, import.meta.server, cookies);
  const auth = useAuthApi(config.public.apiHost, import.meta.server, cookies);

  return {
    provide: {
      api: {
        dashboard,
        device,
        user,
        weather,
        camera,
        auth
      }
    }
  };
});
